<template>
  <div class="sales-statistics">



        <el-form class="select">

            <el-form-item label="教师姓名:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择"
                v-model="teacherName"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in teacherArr"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                >
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select
                placeholder="请选择所在地域"
                v-model="regionName"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="item in optionsListt"
                  :key="item.id"
                  :value="item.dictType"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="日期:" label-width="100px" style="width: 50%;text-align: justify;">
              <el-date-picker
                v-model="dateTimeLists"
                type="month"
                style="width: 100%;"
                value-format="yyyy-MM"
                placeholder="选择年月">
              </el-date-picker>
            </el-form-item>



            <el-form-item label="状态:" label-width="100px" style="width: 30%;">
              <el-select v-model="newClassType"  filterable placeholder="请选择状态"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>



            <el-form-item style="width: 100%;">
              <div style="display: flex;">
                <div style="width: 55%;"></div>
                <div style="display: flex;width: 55%; flex-wrap: wrap;">
                    <div style="width: 100%;text-align: end;">
                      <!-- <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-thumb" @click="exportBtnss">一键课消</el-button> -->
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                      <el-button style="height: 34px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
                    </div>
                </div>
              </div>
            </el-form-item>


            </el-form>



            <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataList" border height="700">
            <el-table-column prop="teacherName" label="教师姓名" ></el-table-column>
            <el-table-column prop="regionName" label="所在地域"></el-table-column>
            <el-table-column prop="notarizeDate" label=" 年/月" > </el-table-column>
            <el-table-column prop="classSalesNum" label="实际课消次数" width="250"></el-table-column>
            <el-table-column prop="notarizeType" label="状态" >
             <template v-slot="scope">
               <span v-if="scope.row.notarizeType === 1">待确认</span>
               <span v-if="scope.row.notarizeType === 2">已确认</span>
               <span v-if="scope.row.notarizeType === 3">复核中</span>
             </template>
            </el-table-column>
            <el-table-column header-align="center" label="查看详情" >
              <template slot-scope="scope">
                <el-button type="text" @click="details(scope.row)">详情</el-button>
              </template>
            </el-table-column>
            </el-table>


            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
            layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
            </el-pagination>


            <el-card v-if="ShowCourseSalesStatisticsDetails" style="position: fixed;width: 100%;top: 70px; height: 100%;left: 0;z-index: 111;">
              <CourseSalesStatisticsDetails v-if="ShowCourseSalesStatisticsDetails" :DetailsRow="DetailsRow" :TimeList="TimeList" @handleEmitButs="handleEmitButs" :isNewClassType="newClassType"></CourseSalesStatisticsDetails>
            </el-card>
  

  




  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import CourseSalesStatisticsDetails from './CourseSalesStatisticsDetails.vue'
import { getTeachers_s,  } from "@/api/firstClassApi";
import {  getStudentsType } from "@/api/fiveClassApi"
import Vue from 'vue';
import { ref, reactive, onMounted, getCurrentInstance, nextTick, onUpdated  } from '@vue/composition-api'
var $Vue = Vue.prototype
import { useStore } from '../pinia/stores.js'
import { Loading } from 'element-ui';



export default {
  components:{
    CourseSalesStatisticsDetails,
  },

  setup(props, { root, refs }) {


    // 获取当前日期
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // 月份从0开始

    // 补零函数
    function pad(n) {
      return n < 10 ? '0' + n : n;
    }

    // 当前月第一天
    const firstDay = `${year}-${pad(month)}-01`;
    // 当前月最后一天
    const lastDay = new Date(year, month, 0).getDate();
    const currentDay = `${year}-${pad(month)}-${pad(lastDay)}`;

    let newClassType =  ref('')
    let newClassTypeList = ref([
      {id:1,name:'待确认'},
      {id:2,name:'已确认'},
      {id:3,name:'复核中'},
    ])

    let activeName =  ref('first')
    let getStudentsArr = ref([])
    let getStudentsArr_s = ref([])
    let student_s = ref("")
    let student = ref("")
    let requestParameters = reactive({ pageSize: 10, pageNum: 1,  total: 0,})
    let dateTimeList = ref([firstDay,currentDay])
    let dateTimeLists = ref('')
    let dateTimeList_s = ref([firstDay,currentDay])
    let teacherName = ref("")
    let cancellationsNumber_s = ref("")
    let cancellationsMoney_s = ref("")
    let cancellationsNumber = ref("")
    let cancellationsMoney = ref("")
    let dataList = ref([])
    let dataList_s = ref([])
    let teacherArr = ref([])
    let ShowCourseSalesStatisticsDetails = ref(false)
    let ShowCourseSalesStatisticsDetails_s = ref(false)
    let DetailsRow = reactive({})
    let TimeList = ref([])
    let typeCourseConsumptionStatistics = ref(1)
    let dataTop = reactive({ actualNumCount: 0, actualMoneyCount: 0,  notNumCount: 0,  notMoneyCount: 0, estimateNumCount: 0, estimateMoneyCount: 0})
    let dataTop_s = reactive({ actualNumCount: 0, actualMoneyCount: 0,  notNumCount: 0,  notMoneyCount: 0, estimateNumCount: 0, estimateMoneyCount: 0})
    let requestParameters_s = reactive({ pageSize: 10, pageNum: 1,  total: 0,})
    let requestType = ref('')

    const instance = getCurrentInstance()
    let dataListactualCourseConsumptionStatistics = ref([])
    let requestParametersalCourseConsumptionStatistics = reactive({ pageSize: 10, pageNum: 1,  total: 0,})

    let TotalAmountOfCourseCancellations = ref(0)
    let TotalCourseHoursToBeCancelled = ref(0)
    let TodaysTotalAmountOfNewlyAddedClassExpenses = ref(0)
    let TodaysNewlyAddedClassHours = ref(0)

    let sortingRules = ref(1)
    let sortingRulesArr = ref([{ id:1, realname:'按实际课消金额排序'},{id:2, realname:'按预课消金额排序'}])
    let sortingRuless = ref(1)

    let regionName = ref('')
    let optionsListt = ref([
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ])

    onMounted(()=>{

        getListData()
        //  dataList.value = [{ ownerDate: '2024-11-31', teacherName:'岁岁平岁岁安·岁岁平安', classNum:'123' }]
        handleGetTeacher()
        getStudentsType(2).then((res) => {  getStudentsArr.value = res.data })
        getStudentsType(1).then((res) => {  getStudentsArr_s.value = res.data })

        getOptionsList()

    })


    onUpdated(() => {
        nextTick(() => {
            handleInit()

            let cellDom = document.querySelectorAll('.cell')

            for (let element of cellDom) {
                // if(element.innerHTML === '实际课消次数'){
                //     element.style.color = 'rgb(245, 140, 75)'
                // }
                // if(element.innerHTML === '实际课消金额'){
                //     element.style.color = 'rgb(209, 198, 51)'
                // }
                // if(element.innerHTML === '未课消次数'){
                //     element.style.color = 'rgb(150, 233, 149)'
                // }
                // if(element.innerHTML === '未课消金额'){
                //     element.style.color = 'rgb(194, 245, 75)'
                // }
                // if(element.innerHTML === '预课消总次数'){
                //     element.style.color = 'rgb(93, 235, 158)'
                // }
                // if(element.innerHTML === '预课消总金额'){
                //     element.style.color = 'rgb(227, 154, 89)'
                // }

            }

        })
    })

    const getOptionsList = () => {
      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
        optionsListt.value = res.data.data
        console.log("%c Line:760 🥓 optionsListt.value", "color:#7f2b82", optionsListt.value);
      })
    }

    const getOptions = () => {
        return request({
            url: '/api/manager/courseSalesStatistics/getOptions',
            method: 'get'
        })
    }

    const getTableData = () => {
        getTableDataList().then(res => {
            if (res.code === 200) {
                tableData.value = res.data
            }
        })
    }

    const formatDate = (date) =>{
        return date.toISOString().split('T')[0];
    }

    const handleInit = () =>{
        const today = new Date()
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 2)
        const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1)


        let firstDayOfMonthNew = formatDate(firstDayOfMonth)
        let lastDayOfMonthNew = formatDate(lastDayOfMonth)

      setTimeout(()=>{
          // dateTimeList.value[0] = firstDayOfMonthNew
          // dateTimeList.value[1] = lastDayOfMonthNew
          // dateTimeList_s.value[0] = firstDayOfMonthNew
          // dateTimeList_s.value[1] = lastDayOfMonthNew
      },1000)
    }

    const handleClick = (tab, event) =>{
          if(tab.paneName === 'first'){
            requestType.value = ''
            sortingRuless.value = 1
            handleTpyeCler(tab.paneName)
          }
          if(tab.paneName === 'second'){
            requestType.value = 'requestType'
            sortingRules.value = 1
            handleTpyeCler(tab.paneName)
          }

          if(tab.paneName === 'actualCourseConsumptionStatistics'){
            axios.get(`${apiBaseUrl}/reality_classSales/findCollect`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {

                if(response.data.code == 200){
                  const data = response.data
                  TotalAmountOfCourseCancellations.value = data.data.courseStayMoney
                  TotalCourseHoursToBeCancelled.value = data.data.courseStayHour
                  TodaysTotalAmountOfNewlyAddedClassExpenses.value = data.data.todayClassSalesMoney
                  TodaysNewlyAddedClassHours.value = data.data.todayClassSalesHour
                }else{
                  TotalAmountOfCourseCancellations.value = 0
                  TotalCourseHoursToBeCancelled.value = 0
                  TodaysTotalAmountOfNewlyAddedClassExpenses.value = 0
                  TodaysNewlyAddedClassHours.value = 0
                }

            }).catch(error => {
                handleMessage(error, 'error')
            })
            handleInitList(tab.paneName)
          }

    }


    const handleInitList = (value) =>{
      getListDataalCourseConsumptionStatistics()
    }


    const handleTpyeCler = (bomb) =>{
        dateTimeList.value[0] = firstDay
        dateTimeList.value[1] = currentDay
        dateTimeList_s.value[0] = firstDay
        dateTimeList_s.value[1] = currentDay

        if(bomb === 'first'){
            clearBtns()
        }else{
            handleCler()
        }
    }

    const handleCler = () =>{
      cancellationsNumber_s.value = ""
      cancellationsMoney_s.value = ""
      requestParameters.pageNum = 1
      requestParameters.pageSize = 10

      // dateTimeList_s.value = []
      student_s.value = ""
      student.value = ""
      newClassType.value = ""
      dateTimeLists.value = ""
      let str = []
      if(student.value){
        str.push(student.value)
        if(student_s.value){
          str.push(student_s.value)
        }
      }else{
        if(student_s.value){
          str.push(student_s.value)
        }
      }

      if(dateTimeList_s.value && dateTimeList_s.value.length > 0){
        let data = {
              pageNum: requestParameters.pageNum,  //第几页 必传
              pageSize: requestParameters.pageSize,   //每页几条 必传
              teacherId: teacherName.value,   //老师id 非必传
              regionName: regionName.value,    //地域id 非必传
              notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
              notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
        }

        getListData(data)
      }else{
        let data = {
              pageNum: requestParameters.pageNum,  //第几页 必传
              pageSize: requestParameters.pageSize,   //每页几条 必传
              teacherId: teacherName.value,   //老师id 非必传
              regionName: regionName.value,    //地域id 非必传
              notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
              notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
            }
          getListData(data)
      }

    }

    let exportBtns = () =>{

      if(requestType.value === 'requestType'){
          let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }
          let data = {
              // pageNum: requestParameters.pageNum,  //第几页 必传
              // pageSize: requestParameters.pageSize,   //每页几条 必传
              teacherId: teacherName.value,   //老师id 非必传
              regionName: regionName.value,    //地域id 非必传
              notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
              notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中

          }
          axios.post(`${apiBaseUrl}/teacherHourAudit/export`, data, { responseType: "blob",
          headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
            if(response.status == 200){

              const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
              const downloadLink = document.createElement("a");
              downloadLink.href = URL.createObjectURL(blob);
              downloadLink.download = "老师课时审批.xlsx";
              downloadLink.click();

              handleMessage('导出成功', 'success')
            }else{
              handleMessage('导出失败', 'error')
            }
          })
      }else{
        let data = {
              // pageNum: requestParameters.pageNum,  //第几页 必传
              // pageSize: requestParameters.pageSize,   //每页几条 必传
              teacherId: teacherName.value,   //老师id 非必传
              regionName: regionName.value,    //地域id 非必传
              notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
              notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
        }
        axios.post(`${apiBaseUrl}/teacherHourAudit/export`, data, { responseType: "blob",
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')

        } }).then(response => {
          if(response.status == 200){

            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = "老师课时审批.xlsx";
            downloadLink.click();

            handleMessage('导出成功', 'success')
          }else{
            handleMessage('导出失败', 'error')
          }
        })
      }


    }

    let exportBtnss = () =>{
      axios.get(`${apiBaseUrl}/classSales/createClassSales`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then(response => {
          if(response.data.code == 200){
            let data = {
              pageNo: requestParameters.pageNum ? requestParameters.pageNum : 1,
              pageSize: requestParameters.pageSize,
            }

            handleMessage('操作成功', 'success')

            setTimeout(()=>{
              getListData(data)
            },1000)

          }else{
            handleMessage('操作失败', 'error')
          }
      })
    }

    let clearBtns = () =>{
      if(requestType.value !== 'requestType'){
          // dateTimeList.value = []
          teacherName.value = ""
          cancellationsNumber.value = ""
          cancellationsMoney.value = ""
          regionName.value = ""
          newClassType.value = ""
          dateTimeLists.value = ''

          requestParameters.pageNum = 1
          requestParameters.pageSize = 10
          
        if(dateTimeList.value && dateTimeList.value.length > 0){
          let data = {
            pageNum: requestParameters.pageNum,  //第几页 必传
            pageSize: requestParameters.pageSize,   //每页几条 必传
            teacherId: teacherName.value,   //老师id 非必传
            regionName: regionName.value,    //地域id 非必传
            notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
            notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
          }

          getListData(data)
        }else{
            let data = {
              pageNum: requestParameters.pageNum,  //第几页 必传
              pageSize: requestParameters.pageSize,   //每页几条 必传
              teacherId: teacherName.value,   //老师id 非必传
              regionName: regionName.value,    //地域id 非必传
              notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
              notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
            }
            getListData(data)
        }
      }else{
        handleCler()
      }
    }


    const handleQueryType = (destroyer) =>{
      if(destroyer === 'bomm'){

          // dateTimeList.value = []
          teacherName.value = ""
          cancellationsNumber.value = ""
          cancellationsMoney.value = ""

          let data = {
            pageNum: requestParameters.pageNum,  //第几页 必传
            pageSize: requestParameters.pageSize,   //每页几条 必传
            teacherId: teacherName.value,   //老师id 非必传
            regionName: regionName.value,    //地域id 非必传
            notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
            notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
          }

          getListData(data)
      }
      if(destroyer === 'blast'){
          cancellationsNumber_s.value = ""
          cancellationsMoney_s.value = ""
          // dateTimeList_s.value = []
          student_s.value = ""
          student.value = ""


          let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }

          let data = {
            pageNum: requestParameters.pageNum,  //第几页 必传
            pageSize: requestParameters.pageSize,   //每页几条 必传
            teacherId: teacherName.value,   //老师id 非必传
            regionName: regionName.value,    //地域id 非必传
            notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
            notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
          }

          getListData(data)
      }
    }

    const store = useStore()

    let details = (row) =>{
        store.row = row
        DetailsRow = row
        ShowCourseSalesStatisticsDetails.value = true
    }

    let details_s = (row) =>{
        store.row = row
        DetailsRow = row
        ShowCourseSalesStatisticsDetails_s.value = true
    }

    let searchBtns = ()  =>{


      if(requestType.value  != 'requestType'){
        if(dateTimeList.value && dateTimeList.value.length > 0){
          let data = {
              pageNum: requestParameters.pageNum,  //第几页 必传
              pageSize: requestParameters.pageSize,   //每页几条 必传
              teacherId: teacherName.value,   //老师id 非必传
              regionName: regionName.value,    //地域id 非必传
              notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
              notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
          }
          getListData(data)
        }else{
          let data = {
              pageNum: requestParameters.pageNum,  //第几页 必传
              pageSize: requestParameters.pageSize,   //每页几条 必传
              teacherId: teacherName.value,   //老师id 非必传
              regionName: regionName.value,    //地域id 非必传
              notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
              notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
          }
          getListData(data)
        }
      }else{
          let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }

          if(dateTimeList_s.value && dateTimeList_s.value.length > 0){
            let data = {
              pageNum: requestParameters.pageNum,  //第几页 必传
              pageSize: requestParameters.pageSize,   //每页几条 必传
              teacherId: teacherName.value,   //老师id 非必传
              regionName: regionName.value,    //地域id 非必传
              notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
              notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
            }
            getListData(data)
          }else{
            let data = {
              pageNum: requestParameters.pageNum,  //第几页 必传
              pageSize: requestParameters.pageSize,   //每页几条 必传
              teacherId: teacherName.value,   //老师id 非必传
              regionName: regionName.value,    //地域id 非必传
              notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
              notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
            }
            getListData(data)
          }
      }


    }


    const handleOnekeyCourseConsumption = () =>{

      requestParametersalCourseConsumptionStatistics.pageNum = 1
      requestParametersalCourseConsumptionStatistics.pageSize = 10



      const loadingObj =  Loading.service({ lock: true,  text: '课消中请稍等...',  spinner: 'el-icon-loading',  background: 'rgba(0, 0, 0, 0.6)'  })

      if(typeCourseConsumptionStatistics.value === 1){
        axios.get(`${apiBaseUrl}/reality_classSales/calculateMoney`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
            if(response.data.code == 200){
              handleMessage(response.data.message, 'success')
              loadingObj.close()
              getListDataalCourseConsumptionStatistics()
            }else{
              loadingObj.close()
              handleMessage(response.data.message, 'error')
            }
        }).catch(error => {
            handleMessage(error, 'error')
            loadingObj.close()
        })
      }

      if(typeCourseConsumptionStatistics.value === 2){
        axios.get(`${apiBaseUrl}/reality_classSales/calculateHour`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
            if(response.data.code == 200){
              handleMessage(response.data.message, 'success')
              loadingObj.close()
              getListDataalCourseConsumptionStatistics()
            }else{
              loadingObj.close()
              handleMessage(response.data.message, 'error')
            }
        }).catch(error => {
            handleMessage(error, 'error')
            loadingObj.close()
        })
      }


      axios.get(`${apiBaseUrl}/reality_classSales/findCollect`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {

      if(response.data.code == 200){
          const data = response.data
          TotalAmountOfCourseCancellations.value = data.data.courseStayMoney
          TotalCourseHoursToBeCancelled.value = data.data.courseStayHour
          TodaysTotalAmountOfNewlyAddedClassExpenses.value = data.data.todayClassSalesMoney
          TodaysNewlyAddedClassHours.value = data.data.todayClassSalesHour
      }else{
          TotalAmountOfCourseCancellations.value = 0
          TotalCourseHoursToBeCancelled.value = 0
          TodaysTotalAmountOfNewlyAddedClassExpenses.value = 0
          TodaysNewlyAddedClassHours.value = 0
      }

      }).catch(error => {
          handleMessage(error, 'error')
      })

    }

    let getListDataalCourseConsumptionStatistics = (data = {
      pageSize: requestParametersalCourseConsumptionStatistics.pageSize ? requestParametersalCourseConsumptionStatistics.pageSize : 10,
      pageNum: requestParametersalCourseConsumptionStatistics.pageNum ? requestParametersalCourseConsumptionStatistics.pageNum : 1,
    }) =>{
      const URL = `/reality_classSales/${typeCourseConsumptionStatistics.value === 1 ? 'findCourseMoneyPage' : 'findCourseHourPage'}`
      axios.post(`${apiBaseUrl}${URL}`, data,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
        let data = response.data
        if (data.code == 200) {
              handleMessage('查询成功', 'success')
              if( data.data.records && data.data.records.length > 0 ){
                  requestParametersalCourseConsumptionStatistics.total = data.data.total
                  requestParametersalCourseConsumptionStatistics.pageNum = data.data.current
                  requestParametersalCourseConsumptionStatistics.pageSize = data.data.size
                  dataListactualCourseConsumptionStatistics.value = data.data.records
              }else{
                  requestParametersalCourseConsumptionStatistics.total = 0
                  requestParametersalCourseConsumptionStatistics.pageNum = 1
                  requestParametersalCourseConsumptionStatistics.pageSize = 10
                  dataListactualCourseConsumptionStatistics.value = []
              }
          }else{
            handleMessage('查询失败', 'error')
        }
        })
        .catch(error => {
          handleMessage(error, 'error')
        });
    }


    let getListData = (data = {
        // pageSize: requestParameters.pageSize, pageNo: requestParameters.pageNum,
        // teacherId: teacherName.value,
        // // courseStartTime: dateTimeList.value[0],
        // // courseEndTime: dateTimeList.value[1],
        // startTime: dateTimeList.value[0],
        // endTime: dateTimeList.value[1],
        // salesNum: cancellationsNumber.value,
        // salesMoney: cancellationsMoney.value,
        // sortingRules: requestType.value  === 'requestType' ? sortingRuless.value : sortingRules.value,
        // regionName: regionName.value || localStorage.getItem('cityTepy'),
        // classType: newClassType.value ? newClassType.value : '',


        pageNum: requestParameters.pageNum,  //第几页 必传
        pageSize: requestParameters.pageSize,   //每页几条 必传
        teacherId: teacherName.value,   //老师id 非必传
        regionName: regionName.value,    //地域id 非必传
        notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
        notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中


    }) => {
      let URL = ''
      if(requestType.value  === 'requestType'){
            TimeList.value = dateTimeList_s.value
            URL = '/classSales/queryStuClassSales'
      }else{
            TimeList.value = dateTimeList.value
            URL = '/teacherHourAudit/findPage'
      }

      axios.post(`${apiBaseUrl}${URL}`, data,{headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {

        let list = response.data
        if (list.code == 200) {
              handleMessage('查询成功', 'success')
              if(requestType.value  === 'requestType'){
                  requestParameters.total = list.data.total
                  requestParameters.pageNum = list.data.current
                  requestParameters.pageSize = list.data.size
                  dataList.value =  list.data.records
              }else{
                  requestParameters.total = list.data.total
                  requestParameters.pageNum = list.data.current
                  requestParameters.pageSize = list.data.size
                  dataList.value =  list.data.records
              }
          }else{
            requestParameters.total = 0
            requestParameters.pageNum = 1
            requestParameters.pageSize = 10
            dataList.value =  []
            handleMessage('查询失败', 'error')
        }}).catch(error => {
          console.error(error)
          dataList.value =  [
            {
              id: 0,
              teacherId: 0,
              notarizeDate: "2024-2",
              notarizeType: 0,
              doubtContent: JSON.stringify([
               {commitContent:'111啊大打的',auditContent:123},
               {commitContent:'22222大打的',auditContent:123},
               {commitContent:'的333333大打的',auditContent:123},
               {commitContent:'的的44444444444大打的',auditContent:123},
               {commitContent:'的55555555555555打的',auditContent:123},
               {commitContent:'的的66666666666666666666666666666666666666打的',auditContent:123},
               {commitContent:'1231234176754645645',auditContent:123},
               {commitContent:'adsa大撒大声地adsa大撒大声地adsa大撒大声地adsa大撒大声地adsa大撒大声地adsa大撒大声地adsa大撒大声地adsa大撒大声地adsa大撒大声地adsa大撒大声地adsa大撒大声地',auditContent:123},
              ]),
              teacherName: "teacherName_c8d57ee3e75f",
              regionName: "regionName_0243d473bcca",
              classSalesNum: "classSalesNum_73403bf5c31a",
              studentIds: "studentIds_f86f417f708b",
              classType: 0,
              categoryId: 0,
              educationType: 0,
           },
          ]
          handleMessage(error, 'error')
        });
    }

    let handleMessage = (message , type)=>{
      $Vue.$message({ message, type, duration: 500 })

    }


    let handleGetTeacher = () =>{
      getTeachers_s().then((res) => {
        teacherArr.value = res.data
      })
    }


    let handleCurrentChange = (current) =>{
        requestParameters.pageNum = current
        getListData()
    }


    let handleCurrentChangealCourseConsumptionStatistics = (current) =>{
        requestParametersalCourseConsumptionStatistics.pageNum = current
        getListDataalCourseConsumptionStatistics()
    }

    let handleSizeChangealCourseConsumptionStatistics = (current) =>{
        requestParametersalCourseConsumptionStatistics.pageNum = current
        getListDataalCourseConsumptionStatistics()
    }


    let handleSizeChange = (Size) =>{
        requestParameters.pageSize = Size
        getListData()
    }

    let handleCurrentChange_s = (current) =>{
        requestParameters_s.pageNum = current
        let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }
        let data = {
              pageNum: requestParameters.pageNum,  //第几页 必传
              pageSize: requestParameters.pageSize,   //每页几条 必传
              teacherId: teacherName.value,   //老师id 非必传
              regionName: regionName.value,    //地域id 非必传
              notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
              notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
            }
            getListData(data)
    }

    let handleSizeChange_s = (Size) =>{
        requestParameters_s.pageSize = Size
        let str = []
          if(student.value){
            str.push(student.value)
            if(student_s.value){
              str.push(student_s.value)
            }
          }else{
            if(student_s.value){
                str.push(student_s.value)
            }
          }
        let data = {
              pageNum: requestParameters.pageNum,  //第几页 必传
              pageSize: requestParameters.pageSize,   //每页几条 必传
              teacherId: teacherName.value,   //老师id 非必传
              regionName: regionName.value,    //地域id 非必传
              notarizeDate: dateTimeLists.value,    //日期年月 格式yyyy-MM
              notarizeType: newClassType.value,    //确认状态 1待确认 2已确认 3复核中
            }
            getListData(data)
    }


    let handleEmitButs = (event, destroyer) =>{
        ShowCourseSalesStatisticsDetails.value = event
        ShowCourseSalesStatisticsDetails_s.value = event

        handleQueryType(destroyer)

    }


    let handleClickTab = (type)=>{
        if(type === 1 || type === 2){
            requestParametersalCourseConsumptionStatistics.total = 0
            requestParametersalCourseConsumptionStatistics.pageNum = 1
            requestParametersalCourseConsumptionStatistics.pageSize = 10
            dataListactualCourseConsumptionStatistics.value = []
            typeCourseConsumptionStatistics.value = type
            getListDataalCourseConsumptionStatistics()
        }
    }


    let changeSortingRules = (event) =>{
      getListData()
    }

    let changeSortingRuless = (event) =>{
      getListData()
    }


    return {
      handleClickTab,
      requestParameters,
      dateTimeList,
      teacherName,
      cancellationsNumber,
      cancellationsMoney,
      dataList,
      teacherArr,
      ShowCourseSalesStatisticsDetails,
      ShowCourseSalesStatisticsDetails_s,
      DetailsRow,
      TimeList,
      dataTop,
      activeName,
      getStudentsArr,
      getStudentsArr_s,
      student,
      student_s,
      cancellationsNumber_s,
      cancellationsMoney_s,
      dateTimeList_s,
      requestParameters_s,
      handleCurrentChange_s,
      handleSizeChange_s,
      dataTop_s,
      dataList_s,

      exportBtnss,
      exportBtns,
      searchBtns,
      clearBtns,
      getListData,

      handleEmitButs,
      details,
      details_s,
      formatDate,
      handleCurrentChange,
      handleSizeChange,

      handleMessage,
      handleGetTeacher,
      handleClick,
      handleTpyeCler,
      handleInit,

      handleInitList,
      dataListactualCourseConsumptionStatistics,
      handleCurrentChangealCourseConsumptionStatistics,
      handleSizeChangealCourseConsumptionStatistics,
      requestParametersalCourseConsumptionStatistics,
      handleOnekeyCourseConsumption,
      typeCourseConsumptionStatistics,

      TotalAmountOfCourseCancellations,
      TotalCourseHoursToBeCancelled,
      TodaysTotalAmountOfNewlyAddedClassExpenses,
      TodaysNewlyAddedClassHours,

      sortingRules,
      sortingRulesArr,
      changeSortingRules,
      sortingRuless,
      changeSortingRuless,


      optionsListt,
      regionName,


      newClassTypeList,
      newClassType,

      dateTimeLists,
    }



  }

}


</script>

<style scoped>
.select {
  display: flex;
  flex-wrap: wrap;
}

@media screen and (max-width: 750px) {
  .sales-statistics {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.sales-statistics {
    width: 70% !important;
  }
}

.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}



.glow-effect {
  position: relative;
  overflow: hidden;
}

.glow-effect::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, #0fb2f6, #18dec5, #0fb2f6);
  background-size: 400% 400%;
  animation: glow 5s ease-in-out infinite;
  z-index: -1;
}

@keyframes glow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.clickable-text {
  color: red;
  cursor: pointer;
}






</style>



// WEBPACK FOOTER //
// src/TeacherClassApproval/TeacherClassApproval.vue